import { Navigate } from "react-router-dom";
import { useRole } from "@/contexts/RoleContext";
import { useAuth } from "@/contexts/AuthContext";

/**
 * RoleBasedDashboard - Routes users to appropriate dashboard based on their role
 *
 * This component acts as a router that directs authenticated users to their
 * role-specific dashboard:
 * - Partners → /partner/dashboard (client management)
 * - Clients → /client/dashboard (instance management)
 * - Admins → /admin/dashboard (system administration)
 *
 * Used as the default landing page after authentication.
 */
export function RoleBasedDashboard() {
  const { isLoading } = useAuth();
  const { role, getDefaultRoute } = useRole();

  // Wait for auth to load
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="text-slate-400">Loading...</div>
      </div>
    );
  }

  // If no role, redirect to login
  if (!role) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to role-specific dashboard
  return <Navigate to={getDefaultRoute()} replace />;
}
